<template >
    <div class="container-fluid" v-if="student">

      <div class="card mb-4" >
        <div class="card-header py-3">
          <div class="row">
            <div class="col col-expand">
              <h4 class="m-0 font-weight-bold text-primary">{{student.name}},  {{student.register}} шинэ оюутны мэдээлэл</h4>
            </div>
            <div class="col col-auto" v-if="student.student">
              <button class="btn btn-primary btn-sm" @click="$router.push({name : 'StudentDetail', params:{studentId: student.student.id}})">Оюутан харах</button>
            </div>
            <div class="col col-auto" v-else>
              <button class="btn btn-success btn-sm" @click="generateCode">Оюутан үүсгэх</button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <p>Ургийн овог: {{student.urag}}</p>
          <p>Яс үндэс: {{student.yasundes}}</p>
          <p>Овог: {{student.lastname}}</p>
          <p>Нэр: {{student.name}}</p>
          
          
          <p >Регистрийн дугаар: {{student.register}}</p>
          <p >Имэйл: {{student.email}}</p>
          <p >Утасны дугаар: {{student.phone}}</p>
          <p v-if="student.school">Сургууль: {{student.school.id}}</p>
          <p v-if="student.department">Xөтөлбөрийн баг: {{student.department.id}}</p>
          <p v-if="student.program">Хөтөлбөр: {{student.program.id}}</p>
          <!-- <hr/> -->
          <p >
            Хүйс: <span v-if="student.gender=='male'">эр</span><span v-if="student.gender=='female'">эм</span>
          </p>
          <p >Төрсөн огноо: 
            <span v-if="student.birth">{{student.birth.year}}/{{student.birth.month}}/{{student.birth.day}}</span>
          </p>
          <p >Элссэн :<span v-if="student.entry&&student.entry.data"> {{student.entry.data.year}}</span></p>
          <p >Төгссөн сургууль: {{student.past_school}}</p>
          <p >Төгссөн он: {{student.past_gradyear}}</p>
          <p >Голч: {{student.past_score}}</p>
          <p >Дипломын дугаар: {{student.past_school_diplomaid}}</p>
          <p >Мэргэжил: {{student.past_school_profession}}</p>
          <p >Ажил эрхлэлт: {{student.baiguullaga}}</p>
          <p >Албан тушаал: {{student.albantushaal}}</p>
          <p >
            Оршин суугаа хаяг: 
            <span v-if="student.iaddress">
              <span>{{student.iaddress.cityName}}</span><br/>
              <span> Дүүрэг/Сум: {{student.iaddress.districtName}}</span><br/>
              <span>Хороо /баг/: {{student.iaddress.horoo}} </span><br/>
              <span>Байшин/Гудам: {{student.iaddress.building}} </span><br/>
              <span> Тоот: {{student.iaddress.entrynumber}}</span>
            </span>
          </p>
            
        </div>

      </div>



    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js');
import { mapState } from 'vuex';
import moment from 'moment';
import firebase from 'firebase';
export default {
    name: "PreStudentDetail",
    data() {
        return {
            student: null,
            semesters:[],
            value: null,
            selectedSemester:null
        };
    },
    methods: {  
      _getStudent(){

        fb.db.collection("prestudents").doc(this.studentId).onSnapshot(doc=> {
            let student=doc.data();
            student.id=doc.id;
            this.student=student;
        });

      },
      setPaidForStudent( value, semester){
        this.setProperty("paid", fb.db.doc("students/"+this.studentId+"/paymentHistory/"+semester.id), value);
      },
      setProperty(propertyName, object, value){
  
        if(object!=null && propertyName!=null){
          var tmp={};
          tmp[propertyName]=value;
          object.set(tmp,{merge:true});
        }
      },
      async generateCode(){
        var r = confirm("Та оюутан үүсгэхдээ итгэлтэй байна уу.");
        if (r == true) {
          if(this.student && this.student.program){
            var searchFunction = firebase.functions().httpsCallable('generateStudentCodeType1');
            this.loading=true;
          console.log({programPath:this.student.program.path });
            var result=await searchFunction({programPath:this.student.program.path });
            console.log(result.data);
                if(result.data!=null && result.data && result.data!="alreadyin"){
                  var doc=await fb.db.collection("students").where("code", "==", result.data.toLowerCase()).get();
                    if(doc && doc.size>0){
                      alert(result.data+" кодтой оюутан бүртгэгдсэн байна.Та дахин оролдоно уу");
                      this.loading=false;
                      return ;
                    }
                    else{
                      this.student.code=result.data.toLowerCase();
                      this.student.register=this.student.register.toLowerCase();
                      var sts=await fb.db.collection("students").where("register", "==", this.student.register).get();
                      if(sts.empty==true){
                        this.student.created=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                        this.student.createdAt=new Date();
                        this.student.prestudent=fb.db.collection("prestudents").doc(this.studentId);
                
                        var docRef=fb.db.collection("students").doc();
                        await docRef.set(this.student);
                        await fb.db.collection("prestudents").doc(this.studentId).update(
                          {
                            "student": docRef,
                            "generatedcode":this.student.code
                          }
                        );
                        this.loading=false;

                        alert(result.data+" кодтой оюутан амжилттай үүслээ");
                      }
                      else{
                        this.loading=false;
                        alert(this.student.register+" регистртэй оюутан бүртгэгдсэн байна");
                      }
          
                      
                    }
        
                  // this.$router.push({ name: 'DetailQuestions', params: { lessonId:this.lessonId, topicId: this.topicId, detailId: result.data} });
                }
                else{
                  this.loading=false;
                  alert("Код үүсгэхэд алдаа гарлаа. Та дахин оролдоно уу.");
                }
          }
        }
        
      }

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        studentId: { 
            required: true,
        }
    },
    created() {
      if(this.studentId!=null && this.studentId!='')
        this._getStudent();
          
    },
    filters: {
        formatDateFromNow(val) {
            if (!val) { return '-' }
            let date = val.toDate()
            return moment(date).fromNow()
        },
        formatDate(val) {
            if (!val) { return '-' }
            let date = val.toDate()
            return moment(date).format('MM/DD/YYYY HH:mm');
        },
        trimLength(val) {
            if (val.length < 200) { return val }
            return `${val.substring(0, 200)}...`
        }
    }
  
};
</script>

